import { CIDS_DOMAIN } from '../../../../cids/constants'
import afterCreateReduxHook from '../../../../redux/hooks/after-create'
import getReduxSelector from '../../../../redux/selectors/get'
import createReduxUtil from '../../../../redux/utils/create'
import getClassNameReduxUtil from '../../../../redux/utils/get-class-name'
import getInstanceReduxUtil from '../../../../redux/utils/get-instance'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import createAssociationsAddReduxUtil from '../../../../redux/actions/create/create-associations'
import addReduxUtil from '../../../utils/add'
import setUtil from '../../../../../utils/set'
import { getObjectUtil } from 'packages/src'

export default function createInstanceAddReduxUtil (stateWrapper, payload) {
  const {
    data,
    domainListPath,
    options
  } = payload

  let {
    existingInstance
  } = payload

  const className = (
    getClassNameReduxUtil(data) || getObjectUtil(data, 'data.className')
  )

  // if (!className) {
  //   logSystemUtil('createInstance').warn('[noop]: no className')
  //   return
  // }

  let cidDomain = stateWrapper.state[CIDS_DOMAIN]
  let cid = cidDomain[className]
  if (!cid) {
    cid = 1
  }

  // Create the instance
  let instance = createReduxUtil({
    ...data,
    className,
    cid
  })

  if (!existingInstance) {
    existingInstance = getReduxSelector(getPathReduxUtil(instance))(stateWrapper.state)
  }

  // if (className === 'WorkoutExercise') {
  //   console.log('existingInstance: ', existingInstance)
  //   console.log('instance: ', instance)
  // }
  // Create the associations
  // e.g. Workout.workoutSections
  instance = createAssociationsAddReduxUtil(stateWrapper, {
    instance,
    existingInstance
  })

  // Add the instance do the state
  stateWrapper.state = addReduxUtil({
    state: stateWrapper.state,
    instance,
    existingInstance,
    domainListPath,
    options
  })
  instance = getInstanceReduxUtil(stateWrapper.state, instance)

  // Trigger the after create hook if there is one
  stateWrapper.state = afterCreateReduxHook(instance, stateWrapper.state, stateWrapper.dispatch)
  instance = getInstanceReduxUtil(stateWrapper.state, instance)

  // Increment the cid
  if (!existingInstance) {
    cidDomain = {
      ...stateWrapper.state[CIDS_DOMAIN],
      [className]: cid + 1
    }

    // Set the cid
    stateWrapper.state = setUtil(stateWrapper.state, CIDS_DOMAIN, cidDomain)
  }
  return instance
}
